module.exports = __webpack_public_path__ + "static/playgroup-2-d97ad2b55f435ac159768d0e4d50abea.jpg";